import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { RegexConfig } from '../../configs/config';
import { isMobile } from '../../configs/utils';
import { ACTION } from './types';
import { ROUTE } from '../../routes';
const _isMobile = isMobile();
export const AdditionalDetailsDS = (cityData, referredPartner, metaData, showEmailScreen, showARNScreen) => {
    const DS = {
        additionalDetailContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            hide: !showEmailScreen || showARNScreen,
            maxWidth: _isMobile ? '100%' : 400,
            bgColor: ColorTokens.White,
            borderConfig: {
                borderColor: ColorTokens.Primary_10,
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: _isMobile ? {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
            } : {
                left: SizeTypeTokens.Size32,
                right: SizeTypeTokens.Size32,
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'additionalDetailTitle', type: WIDGET.TEXT },
                { id: 'additionalDetailSpace0', type: WIDGET.SPACE },
                { id: 'nameInput', type: WIDGET.INPUT },
                { id: 'additionalDetailSpace1', type: WIDGET.SPACE },
                { id: 'emailInput', type: WIDGET.INPUT },
                { id: 'additionalDetailSpace2', type: WIDGET.SPACE },
                // { id: 'additionalCityInput', type: WIDGET.CITY_SELECTION_INPUT },
                { id: 'additionalCityInput', type: WIDGET.INPUT },
                { id: 'additionalDetailSpace3', type: WIDGET.SPACE },
                { id: 'companyNameInput', type: WIDGET.INPUT },
                { id: 'additionalDetailSpace4', type: WIDGET.SPACE },
                { id: 'additionalDetailContinueBtn', type: WIDGET.BUTTON },
            ],
        },
        additionalDetailContinueBtn: {
            type: ButtonTypeTokens.LargeOutline,
            label: 'Continue',
            width: ButtonWidthTypeToken.FULL,
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            lineHeight: SizeTypeTokens.XXL,
            fontWeight: '700',
            action: {
                type: ACTION.ADDITIONAL_DETAIL,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    referredPartner: referredPartner
                },
            },
        },
        nameInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            title: 'Full Name *',
            placeholder: 'Name',
            keyboardType: KeyboardTypeToken.default,
            isFocus: false,
            regex: RegexConfig.SPECIAL_CHARACTERS,
            metaData: metaData,
            action: {
                type: ACTION.CHANGE_INPUT,
                payload: {
                    value: '',
                    widgetId: 'nameInput',
                },
            },
            caption: { error: "Please enter a valid name" }
        },
        emailInput: {
            title: 'Email address *',
            isFocus: false,
            fontFamily: FontFamilyTokens.Inter,
            keyboardType: KeyboardTypeToken.email,
            fontSize: FontSizeTokens.MD,
            lineHeight: 24,
            fontWeight: '400',
            placeholder: 'Communication email',
            color: ColorTokens.Grey_Smoke,
            state: InputStateToken.DEFAULT,
            metaData: metaData,
            action: {
                type: ACTION.CHANGE_INPUT,
                payload: {
                    value: '',
                    widgetId: 'emailInput',
                },
            },
            successAction: {
                type: ACTION.EMAIL_SUCCESS,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {},
            },
            errorAction: {
                type: ACTION.DISABLE_SUBMIT,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: false
                },
            },
        },
        companyNameInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            title: 'Company name',
            placeholder: 'Company name (Optional)',
            keyboardType: KeyboardTypeToken.default,
            isFocus: false,
            metaData: metaData,
            action: {
                type: ACTION.CHANGE_INPUT,
                payload: {
                    value: '',
                    widgetId: 'companyNameInput',
                },
            },
        },
        additionalCityInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            title: 'City *',
            placeholder: 'City',
            keyboardType: KeyboardTypeToken.default,
            isFocus: false,
            metaData: metaData,
            regex: RegexConfig.SPECIAL_CHARACTERS,
            caption: { error: "Please enter a valid city name" },
            action: {
                type: ACTION.CHANGE_INPUT,
                payload: {
                    value: '',
                    widgetId: 'additionalCityInput',
                },
            },
        },
        additionalDetailTitle: {
            label: 'Complete your empanelment',
            fontSize: FontSizeTokens.LG,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '400',
            metaData: metaData,
        },
        additionalDetailSpace0: {
            size: SizeTypeTokens.XXL,
        },
        additionalDetailSpace1: {
            size: SizeTypeTokens.XXL,
        },
        additionalDetailSpace2: {
            size: SizeTypeTokens.XXL,
        },
        additionalDetailSpace3: {
            size: SizeTypeTokens.XXL,
        },
        additionalDetailSpace4: {
            size: SizeTypeTokens.XXL,
        },
    };
    return DS;
};
